const translations = {
    title: {
        homePage: 'Plugins Template',
        exemples: 'Examples',
        systemInfo: 'System info',
        userInfo: 'User info'
    },
    paragraph: {
        homeDescription: {
            part1: 'This is a basic plugin template.',
            part2: 'Edit <1>src/pages/Home.js</1> and save to reload.'
        }
    },
    link: {
        blipDataExample: 'Get blip data',
        swrExemple: 'SWR fetch data'
    },
    button: {
        repository: 'Visit the Repository'
    },
    menu: {
        goBack: 'Back'
    },
    name: 'Name',
    shortName: 'Short name',
    email: 'E-mail',
    phone: 'Phone',
    identity: 'Identity',
    identifier: 'Identifier',
    language: 'Language',
    accessKey: 'Access key',
    template: 'Template',
    creationDate: 'Creation date'
};

export default translations;
